'use strict';

// export this package's api
module.exports = require('./Pagination');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.1.7.0@rc-pagination/lib/index.js
 ** module id = 422
 ** module chunks = 0
 **/